import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsOverview = ({ metricsData }) => {
  const metrics = [
    {
      id: 'downloads',
      title: 'Total Downloads',
      value: metricsData?.totalDownloads || 0,
      change: '+12%',
      changeType: 'positive',
      icon: 'Download',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
      description: 'Mobile app downloads'
    },
    {
      id: 'users',
      title: 'Active Users',
      value: metricsData?.totalActiveUsers || 0,
      change: '+8%',
      changeType: 'positive',
      icon: 'Users',
      color: 'text-green-600',
      bgColor: 'bg-green-50',
      description: 'Monthly active users'
    },
    {
      id: 'engagement',
      title: 'Page Clicks',
      value: Object.values(metricsData?.pageClicks || {})?.reduce((sum, clicks) => sum + clicks, 0),
      change: '-3%',
      changeType: 'negative',
      icon: 'MousePointer',
      color: 'text-purple-600',
      bgColor: 'bg-purple-50',
      description: 'Total page interactions'
    },
    {
      id: 'session',
      title: 'Avg. Session',
      value: `${metricsData?.averageSessionDuration || 0}m`,
      change: '+5%',
      changeType: 'positive',
      icon: 'Clock',
      color: 'text-orange-600',
      bgColor: 'bg-orange-50',
      description: 'Average session duration'
    }
  ];

  const formatValue = (value) => {
    if (typeof value === 'string') return value;
    if (value >= 1000000) return `${(value / 1000000)?.toFixed(1)}M`;
    if (value >= 1000) return `${(value / 1000)?.toFixed(1)}K`;
    return value?.toString();
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {metrics?.map((metric) => (
        <div 
          key={metric?.id}
          className="bg-surface rounded-lg border border-border p-6 hover:shadow-lg transition-shadow duration-200"
        >
          {/* Header */}
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 rounded-lg ${metric?.bgColor} flex items-center justify-center`}>
              <Icon 
                name={metric?.icon} 
                size={24} 
                className={metric?.color}
              />
            </div>
            
            <div className={`flex items-center px-2 py-1 rounded-full text-xs font-medium ${
              metric?.changeType === 'positive' ?'bg-green-50 text-green-700' :'bg-red-50 text-red-700'
            }`}>
              <Icon 
                name={metric?.changeType === 'positive' ? 'TrendingUp' : 'TrendingDown'} 
                size={12} 
                className="mr-1"
              />
              {metric?.change}
            </div>
          </div>

          {/* Value */}
          <div className="mb-2">
            <div className="text-2xl font-bold text-text-primary mb-1">
              {formatValue(metric?.value)}
            </div>
            <div className="text-sm font-medium text-text-primary">
              {metric?.title}
            </div>
          </div>

          {/* Description */}
          <p className="text-xs text-text-secondary">
            {metric?.description}
          </p>

          {/* Progress bar for visual representation */}
          <div className="mt-4">
            <div className="w-full bg-border rounded-full h-2">
              <div 
                className={`h-2 rounded-full transition-all duration-500 ${
                  metric?.changeType === 'positive' ? 'bg-green-500' : 'bg-red-500'
                }`}
                style={{ 
                  width: `${Math.min(100, Math.max(10, (metric?.value || 0) / 10))}%`
                }}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricsOverview;